const s = (c) => {
  const r = (e) => e.length <= 4 ? 5 : e.length <= 7 && e.length >= 5 ? 10 : 25, h = (e) => {
    const t = /[A-Z]/, n = /[a-z]/;
    return e.match(t) && e.match(n) ? 20 : e.match(t) || e.match(n) ? 10 : 0;
  }, i = (e) => {
    const t = e.split("").filter((n) => /\d/.test(n)).length;
    return t >= 3 ? 20 : t >= 1 ? 10 : 0;
  }, S = (e) => {
    const t = e.split("").filter((n) => /[\W|_]/.test(n)).length;
    return t > 1 ? 25 : t == 1 ? 10 : 0;
  }, a = (e, t, n) => e == 20 && t > 0 && n > 0 ? 5 : e > 0 && t > 0 && n > 0 ? 3 : e > 0 && t > 0 ? 2 : 0;
  let f = r(c), u = h(c), o = i(c), l = S(c);
  return {
    score: f + u + o + l + a(u, o, l),
    info: {
      lengthScore: f,
      letersScore: u,
      numberScore: o,
      symbolScore: l
    }
  };
}, m = (c) => {
  const { score: r } = s(c);
  return r < 60 ? "UNSAFE" : r > 80 ? "SAFE" : "NORMAL";
}, k = (c = "") => {
  const { info: r } = s(c);
  return r.lengthScore != 25 ? !1 : r.numberScore > 0 && r.symbolScore > 0 || r.letersScore === 20 || r.letersScore === 10 && r.numberScore > 0 || r.letersScore === 10 && r.symbolScore > 0;
};
export {
  m as checkPwdLevel,
  s as checkPwdScore,
  k as validateRegPwd
};
